<div
  class="container"
  [class.item]="type === 'item'"
  [class.subitem]="type === 'subitem'"
  [class.disabled]="isDisabled"
  [class.highlighted]="isHighlighted"
  [attr.tabindex]="isLoading ? null : 0"
  (click)="toggleExpandClick()"
  (keyup.enter)="toggleExpandClick()"
  (keyup.space)="toggleExpandClick()"
>
  <div class="row align-items-center">
    <div class="col title">
      <h4 class="m-0">{{ title }}</h4>
    </div>
    <div class="col-auto">
      <ng-container *ngIf="isBeingDeleted; else buttons">
        <bom-spinner class="px-4" size="small"></bom-spinner>
      </ng-container>
      <ng-template #buttons>
        <ng-content select="[bom-skift-sag-type]"></ng-content>
        <button
          *ngIf="!isLoading && canBeDeleted && !('Ansoeg' | disableIfRettighedNotAchieved)"
          class="button button-quaternary button-delete"
          [disabled]="isDeleteDisabled"
          (click)="deleteClick(); $event.cancelBubble = true"
          aria-label="slet ansøgning"
        >
          <svg class="icon-svg"><use xlink:href="#delete"></use></svg>
        </button>
      </ng-template>
    </div>
    <div class="col-auto test-angle-arrow">
      <svg class="icon-svg">
        <use xlink:href="#angle-arrow-down" *ngIf="!isExpanded"></use>
        <use xlink:href="#angle-arrow-up" *ngIf="isExpanded"></use>
      </svg>
    </div>
  </div>
  <ng-content select="[bom-sub-title]"></ng-content>
  <div class="row">
    <div class="content" [class.expanded]="isExpanded" [class.loading]="isLoading">
      <ng-container *ngIf="isLoading">
        <bom-spinner size="large"></bom-spinner>
      </ng-container>
      <p *ngIf="shortText" [innerHTML]="shortText"></p>
      <p *ngIf="longText" [innerHTML]="longText"></p>
    </div>
  </div>
</div>
